import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import type { Currency } from '@sequencehq/api'
import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import { XeroIntegrationConfig } from 'modules/Integrations/integrationsConfig/xero/xero.integration.config'
import { persistAutoLinkCustomers } from 'Integrations/integrationsConfig/common/AutoLinkCustomers/persistAutoLinkCustomers'

export const xeroConfigurationMutator = async (
  data: XeroIntegrationConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  const paymentBankAccounts = Object.entries(data.paymentBankAccounts)
    .filter(
      ([currency, bankAccountId]) =>
        (bankAccountId || null) !==
        (data.initialPaymentBankAccounts?.[currency as Currency] || null)
    )
    .map(([currency, bankAccountId]) => ({
      currency: currency as Currency,
      bankAccountId: bankAccountId || null
    }))

  const [result, autoLinkSaved, settingsResult] = await Promise.all([
    dashboardv20240509Client.putIntegration({
      service: 'Xero',
      body: {
        enabled: data.importCustomerWorkflow,
        defaultLedgerAccounts: {
          chargeAccount:
            data.defaultLedgerAccount !== ''
              ? data.defaultLedgerAccount
              : undefined,
          creditAccount:
            data.defaultCreditLedgerAccount !== ''
              ? data.defaultCreditLedgerAccount
              : undefined,
          minimumAccount:
            data.defaultMinimumLedgerAccount !== ''
              ? data.defaultMinimumLedgerAccount
              : undefined,
          taxLiabilityAccount:
            data.defaultTaxLiabilityLedgerAccount !== ''
              ? data.defaultTaxLiabilityLedgerAccount
              : undefined
        },
        defaultTaxCodes: {
          untaxedCustomerTaxCode: data.untaxedCustomerTaxCode
        }
      }
    }),
    persistAutoLinkCustomers('Xero', data.autoLinkCustomers),
    dashboard20240730Client.putXeroSettings({ body: { paymentBankAccounts } })
  ])

  if (result?.error || !autoLinkSaved || settingsResult.error) {
    return {
      success: false,
      error: IntegrationsPortErrors.Other
    }
  }

  return {
    success: true,
    error: null
  }
}
